export default __webpack_public_path__ + "graphic-design.67dabc2b.png";